import { useMutation } from "@tanstack/react-query";
import { fetchPaabudDocumentFile } from "@/api/paabud";

export const useDownloadPaabudDocument = () =>
  useMutation({
    mutationFn: (id: string) => fetchPaabudDocumentFile(id),
  });
